var Label = require('./base');

module.exports = Label;


//////////////////
// WEBPACK FOOTER
// ./src/label/index.js
// module id = 264
// module chunks = 0